export const GET_FREQUENT_LOCATIONS = 'get-frequent-locations';

export default function getFrequentLocations() {
  return {
    type: GET_FREQUENT_LOCATIONS,
  };
}
